/*
 * HTML converter for Strong.
 */
const StrongConverter = {

    type: 'strong',
    tagName: 'strong',

    matchElement: function(el) {
        return el.is('strong, b')
    }
}


export {StrongConverter}
